import React, { Component } from "react";
import "./ReminderTimer.css";
import store from "../../../redux/store";

class ReminderTimer extends Component {
  constructor(props) {
    super(props);
    this.orgTimeZone =
      store.getState().appUserData?.organizationDetails?.timezone || null;

    this.countDownId = null;
    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: false,
    };
  }

  componentDidMount() {
    this.timerInit();
    this.countDownId = setInterval(this.timerInit, 1000);
  }

  componentWillUnmount() {
    if (this.countDownId) clearInterval(this.countDownId);
  }

  timerInit = () => {
    const { startDate } = this.props;
    if (!startDate) {
      this.setState({ expired: true });
      return;
    }

    const orgTZ =
      this.orgTimeZone?.name ||
      Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Current UTC time
    // const nowUTC = new Date().getTime();

    // Get offset between UTC and org timezone in milliseconds
    const nowInOrgTZ = new Date(
      new Date().toLocaleString("en-US", { timeZone: orgTZ })
    ).getTime();

    // Target time in org timezone
    const targetTime = new Date(startDate).getTime();

    // Distance between target and org time
    const distance = targetTime - nowInOrgTZ;

    if (distance <= 0) {
      this.setState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        expired: true,
      });
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.setState({ days, hours, minutes, seconds, expired: false });
  };

  render() {
    const { days, hours, minutes, seconds, expired } = this.state;

    if (expired) {
      return (
        <div
          className="expired"
          style={{
            color: "#c37618",
            fontWeight: "600",
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "start",
          }}
        >
          Expired{" "}
        </div>
      );
    }

    return (
      <div
        className="timer"
        style={{ color: "#c37618", fontWeight: "bold", fontSize: "20px" }}
      >
        {days} days {hours} hrs {minutes} mins {seconds} secs
      </div>
    );
  }
}

export default ReminderTimer;
